import React from 'react';
import FileItemsTableRow from './FileItemsTableRow';
import PropTypes, { shape } from 'prop-types';
import './File.scss';

const FileItemsTable = (props) => {
    
    return(
        <table
            className="table table-hover file-table">
            <thead>
                <tr>
                    <th />
                    <th />
                </tr>
            </thead>
            <tbody>
            {props.files.map(file=>(
                        <FileItemsTableRow
                            key={file.name}
                            file={file}
                            onFilePreviewButtonClick={props.onFilePreviewButtonClick}
                            onFileRemoveButtonClick={props.onFileRemoveButtonClick} />
                    ))}
            </tbody>
        </table>
    );
};

FileItemsTable.propTypes ={
    files: PropTypes.arrayOf(
        shape({
            base64: PropTypes.string,
            name: PropTypes.string
        })
    ),
    onFilePreviewButtonClick: PropTypes.func,
    onFileRemoveButtonClick: PropTypes.func
};

export default FileItemsTable;


// WEBPACK FOOTER //
// ./src/components/File/FileItemsTable.js